<template>
  <module-block
    class="home-hero"
    block="transparent"
  >
    <div class="home-hero__inner group group--first group--last">
      <div class="home-hero__content">
        <h1 class="home-hero__heading h1 mt0 fw-semibold" v-html="hero.heading"/>
        <p
          v-for="(copy, index) in hero.content"
          :key="index"
          class="home-hero__copy p"
          v-html="copy"
        />
      </div>
      <div class="home-hero__get-started">
        <div class="home-hero__form">
          <h4 class="h4 mt0">Are you a Dentist or Endodontist and want to help?</h4>
          <module-form
            form-id="register-dentist"
            :fields="{
              dentistEmail: {
                type: `email`,
                label: `Email`,
                labelHidden: true,
                placeholder: `Enter Your Email`,
              },
            }"

            button="primary"
            button-size="m"
            submit="Sign up now"
            :action="action"
            :success="success"
            :fail="fail"
          />
        </div>
      </div>
    </div>
  </module-block>
</template>

<script>
import { mapGetters } from 'vuex';

// Modules
import ModuleBlock from 'modules/Block';
import ModuleForm from 'modules/Form';

// Export
export default {
  name: `home-hero`,

  // Components
  components: {
    ModuleBlock,
    ModuleForm,
  },

  // Data
  data () {
    return {
      hero: {
        heading: `Building Trust Through Transparency`,
        // image: require(`images/info/icon-illustration-tooth-check.svg`),
        content: [
          `The dental industry is in trouble, and we need your help. There is a wide variety of \
          quality in clinical work done today. However, patients assess quality based on \
          non-clinical experiences like wait times, office décor, doctor friendliness and \
          procedure cost.  While these things matter to patients, what about the work itself? \
          The dental industry needs a way to demonstrate quality and continue to build trust with patients.`,
          `<b>Build your business on quality</b>`,
          `With VeriTooth you can help verify quality clinical work; building trust with patients and promoting high quality work in dentistry.`,
        ],
      },
    };
  },

  computed: {
    ...mapGetters(`forms`, [
      `getModel`,
    ]),
  },

  methods: {
    action() {
      const model = this.getModel(`register-dentist`);

      sessionStorage.setItem(`dentist_email`, model.dentistEmail || ``);

      if (this.isAuthenticated) {
        this.requestLogout({
          noRedirect: true,
        });
      }

      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, 500);
      });
    },
    success() {
      setTimeout(() => {
        this.$router.push({
          name: `register-dentist`,
        });
      }, 500);
    },
    fail(fail) {
      console.warn(fail);
    },
  },

};
</script>



// WEBPACK FOOTER //
// Hero.vue?b0835fd4